export default __webpack_public_path__ + "static/media/include_15@3x.042d0360.jpg";